module.exports = __webpack_public_path__ + "static/media/profile_icon.440b4367.svg";